import { render, staticRenderFns } from "./UsersColumn.vue?vue&type=template&id=305f7c93&lang=pug"
import script from "./UsersColumn.vue?vue&type=script&lang=ts"
export * from "./UsersColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports